module.exports = __webpack_public_path__ + "img/Shopify.02f1e370.svg";